import {
    StockPersonalENTITY,
    SomacylOrderENTITY,
    EquipoLogisticaDTO,
    StockAlmacenENTITY,
    ItemEspañaENTITY,
    ClasificacionIncidencia,
    enumToArray,
} from 'sigo-entities'
import { ViewLoading } from "../../shared/Components/ViewLoading"
import { ViewError } from "../../shared/Components/ViewError"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../shared/Infraestructure/AdapterStore"
import { Formik, FormikHelpers } from "formik"
import * as yup from 'yup'
import { DtoValueOnSelect, IDataEquipos } from "../../shared/Domain"
import { Button, Col, Form, ListGroup, Row } from "react-bootstrap"
import { InputNumber } from "../../shared/Components/ReactBootstrap/InputNumber/InputNumber"
import { InputSelect } from "../../shared/Components/ElementInputsCostume"
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico"
import { TableInventory } from './TableInventory'
import { AdapterGeolocation } from '../../shared/Infraestructure/AdapterGeolocation'
import { Photos } from './Photos'
import { PopupScanner, StrichSDK } from '@pixelverse/strichjs-sdk'
import { sdkLicenseKey } from '../../../scanner-config'
import { MdQrCodeScanner } from 'react-icons/md'
import {
    useSomacylOrdersRepository,
    useStockAlmacenEquiposRepository,
    useStockPersonalEquiposRepository,
    useStockAlmacenRepository,
    useStockPersonalRepository,
} from '../../shared/Infraestructure/hooks'

interface IProps {
    row: SomacylOrderENTITY
    dataItems: ItemEspañaENTITY[]
    ownPersonal: boolean
}

export interface IBodySomacyl {
    ID_Stock: number
    Serie?: string
    cantidad: number
    SerieDeinstall?: {
        Serie: string
        Codigo: string
        Descripcion: string
    }
    lecturaContadorRetirado: string
    lecturaContadorInstalado: string
    observaciones: string
    latitud: number
    longitud: number
    clasificacion_incidencia: ClasificacionIncidencia
}

const dataClasificacion = enumToArray(ClasificacionIncidencia)

export function AddInventory(props: IProps) {
    const { row, dataItems, ownPersonal } = props
    const {
        data: dataAlmacen,
        isLoading: isLoadingAlmacen,
        loadData: findStockAlmacen,
        isError: isErrorAlmacen,
        error: errorAlmacen
    } = useStockAlmacenRepository()
    const {
        data: dataPersonal,
        isLoading: isLoadingPersonal,
        loadData: findStockPersonal,
        isError: isErrorPersonal,
        error: errorPersonal
    } = useStockPersonalRepository()
    const {
        dataEquiposAlmacen,
        isLoading: isLoadingEquiposAlmacen,
        isError: isErrorEquiposAlmacen,
        error: errorEquiposAlmacen,
        findOneStockAlmacenEquipos
    } = useStockAlmacenEquiposRepository()
    const {
        dataEquiposPersonal,
        isLoading: isLoadingEquiposPersonal,
        isError: isErrorEquiposPersonal,
        error: errorEquiposPersonal,
        findOneStockPersonalEquipos
    } = useStockPersonalEquiposRepository()
    const {
        isLoading: isFetchingTransit,
        isError: isErrorTransit,
        error: errorTransit,
        getTransitSomacylOrdersQuery,
        addInventory,
        deleteInventory,
        uploadPhotosSomacylOrders
    } = useSomacylOrdersRepository()
    const { user } = useSelector((state: RootState) => state.auth)
    const [loadingLocation, setLoadingLocation] = useState(false)
    const [equipos, setEquipos] = useState<IDataEquipos[]>([])

    const loadingItem = (): DtoValueOnSelect<ItemEspañaENTITY> => {
        const exist = dataItems.find(item => item.Codigo === 'SOMACYL0000')
        if (!exist) {
            throw new Error('No se encontró el item SOMACYL0000')
        }
        return {
            label: `${exist.Codigo} - ${exist.Descripcion}`,
            value: exist.Codigo,
            dataComplete: exist
        }
    }

    const initialValues = {
        material: new DtoValueOnSelect<StockPersonalENTITY | StockAlmacenENTITY>(),
        equipo: new DtoValueOnSelect<EquipoLogisticaDTO>(),
        item: loadingItem(),
        disponible: 0,
        cantidad: 0,
        serialDeinstall: row.inventario_existente.num_serie_contador_existente,
        lecturaContadorRetirado: row.entregables.lectura_contador_retirado,
        lecturaContadorInstalado: row.entregables.lectura_contador_instalado,
        observaciones: row.entregables.observaciones,
        clasificacion_incidencia: {
            label: row.clasificacion_incidencia,
            value: row.clasificacion_incidencia,
            dataComplete: dataClasificacion.find(e => e.id === row.clasificacion_incidencia)
        },
    }

    type InitialValues = typeof initialValues

    const schema = yup.object().shape({
        material: yup
            .object()
            .shape({ value: yup.string().min(1, 'Seleccione una opción') }),
        equipo: yup
            .object()
            .test({
                test(value, ctx) {
                    if (
                        this.parent.material?.dataComplete?.Item?.Ind_SB === 'S' &&
                        value.value === ''
                    ) {
                        return ctx.createError({
                            path: `${ctx.path}.value`,
                            message: 'Seleccione un equipo',
                        })
                    }
                    return true
                }
            }),
        cantidad: yup.number()
            .required('Campo es requerido')
            .min(1, 'El valor mínimo es 1')
            .test({
                test(value, ctx) {
                    if (value === undefined) return true
                    if (this.options.context?.material?.value) {
                        const disponible = this.options.context?.disponible
                        if (value > disponible) {
                            return ctx.createError({ message: `Cantidad supera lo disponible` })
                        }
                    }
                    return true
                }
            }),
        disponible: yup.number().required('Campo es requerido'),
        item: yup
            .object()
            .test({
                test(value, ctx) {
                    return true
                }
            }),
        serialDeinstall: yup.string()
            .test({
                test(value = '', ctx) {
                    if (
                        this.parent.item?.dataComplete?.Codigo &&
                        this.parent.material?.dataComplete?.Item?.Nombre?.includes('CONTADOR') &&
                        value.length < 1
                    ) {
                        return ctx.createError({ message: `¡Debe ingresar una serie!` })
                    }
                    return true
                }
            }),
        lecturaContadorRetirado: yup.string()
            .trim()
            .required('Campo es requerido'),
        lecturaContadorInstalado: yup.string()
            .trim()
            .required('Campo es requerido'),
        observaciones: yup.string()
            .trim()
            .required('Campo es requerido'),
        clasificacion_incidencia: yup
            .object()
            .test({
                test(value, ctx) {
                    // if (value.value === ClasificacionIncidencia.SIN_CLASIFICACION) {
                    //     return ctx.createError({
                    //         path: `${ctx.path}.value`,
                    //         message: 'Seleccione una clasificación',
                    //     })
                    // }
                    return true
                }
            }),
    })

    const getDataStockPersonal = async () => {
        try {
            const pipeline = [{
                $match: {
                    'Personal.Identificacion': user.Identificacion,
                    'TipoStock.Nombre': 'NUEVO',
                    FlagPex: 0,
                    'Estado.ID_Estado': 2,
                    'Item.GranFamiliaItem.Nombre': 'SOMACYL',
                }
            }]
            await findStockPersonal({ pipeline })
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const getDataStockAlmacen = async () => {
        try {
            const pipeline = [{
                $match: {
                    'Almacen.Codigo': user.AlmacenEmpresa.Codigo,
                    'TipoStock.Nombre': 'NUEVO',
                    'Estado.ID_Estado': 2,
                    'Item.GranFamiliaItem.Nombre': 'SOMACYL',
                }
            }]
            await findStockAlmacen({ pipeline })
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    useEffect(() => {
        if (row._id) {
            if (ownPersonal) {
                getDataStockPersonal()
            } else {
                getDataStockAlmacen()
            }
        }
    }, [row])

    useEffect(() => {
        if (dataEquiposPersonal?.ID_StockPersonalEquipos && dataEquiposPersonal.ID_StockPersonalEquipos > 0) {
            setEquipos(AdapterGenerico.orderEquiposByFecha(dataEquiposPersonal.Equipos))
        }
        if (dataEquiposAlmacen?.ID_StockAlmacenEquipos && dataEquiposAlmacen.ID_StockAlmacenEquipos > 0) {
            setEquipos(AdapterGenerico.orderEquiposByFecha(dataEquiposAlmacen.Equipos))
        }
    }, [dataEquiposPersonal, dataEquiposAlmacen])

    const onSubmitForm = async (
        values: InitialValues,
        formikHelpers: FormikHelpers<InitialValues>
    ) => {
        try {
            setLoadingLocation(true)
            const coodenadas = await AdapterGeolocation.getLocation()
            setLoadingLocation(false)
            const body: IBodySomacyl = {
                ID_Stock: values.material.value as number,
                cantidad: values.cantidad,
                lecturaContadorRetirado: values.lecturaContadorRetirado,
                lecturaContadorInstalado: values.lecturaContadorInstalado,
                observaciones: values.observaciones,
                latitud: coodenadas.latitud,
                longitud: coodenadas.longitud,
                clasificacion_incidencia: values.clasificacion_incidencia.value
            }
            if (values.material.dataComplete.Item.Ind_SB === 'S') {
                body.Serie = values.equipo.dataComplete.Serie
            }
            if (values.material.dataComplete.Item.Nombre?.includes('CONTADOR')) {
                body.SerieDeinstall = {
                    Serie: values.serialDeinstall,
                    Codigo: values.item.dataComplete.Codigo,
                    Descripcion: values.item.dataComplete.Descripcion,
                }
            }
            await addInventory(body, row._id)
            formikHelpers.resetForm()
            AdapterGenerico.createMessage('Información', '¡Agregado!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        } finally {
            setLoadingLocation(false)
        }
    }

    if (isLoadingPersonal || isLoadingAlmacen) return <ViewLoading />
    if (isErrorPersonal || isErrorTransit || isErrorEquiposPersonal || isErrorAlmacen || isErrorEquiposAlmacen) {
        return <ViewError error={errorPersonal || errorTransit || errorEquiposPersonal || errorAlmacen || errorEquiposAlmacen} />
    }

    return (
        <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={onSubmitForm}
        >
            {
                ({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => {
                    return (
                        <>
                            <Form
                                className='d-flex flex-column gap-2 justify-content-between'
                                noValidate
                                onSubmit={handleSubmit}
                            >
                                <ListGroup>
                                    <ListGroup.Item>
                                        <TableInventory row={row} deleteInventory={deleteInventory} isLoading={isFetchingTransit} />
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <Row>
                                            {
                                                ownPersonal ?
                                                    <InputSelect
                                                        label='Material instalado (p)'
                                                        name='material'
                                                        onChange={async (name, value: DtoValueOnSelect<StockPersonalENTITY>) => {
                                                            try {
                                                                const { transito } = await getTransitSomacylOrdersQuery(value.dataComplete.ID_StockPersonal)

                                                                const { Despacho, Devolucion, Liquidacion } = value.dataComplete
                                                                const disponible = Despacho - Devolucion - Liquidacion - transito
                                                                await setFieldValue('disponible', disponible)

                                                                handleChange({ target: { value, name } })
                                                                if (value.dataComplete.Item.Ind_SB === 'S') {
                                                                    await findOneStockPersonalEquipos({ StockPersonal: value.dataComplete })
                                                                    await setFieldValue('cantidad', 1)
                                                                } else {
                                                                    await setFieldValue('equipo', new DtoValueOnSelect<EquipoLogisticaDTO>())
                                                                    await setFieldValue('cantidad', 0)
                                                                }
                                                                handleChange({ target: { value, name } })
                                                            } catch (error) {
                                                                console.error(error)
                                                                AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                            }
                                                        }}
                                                        values={values}
                                                        isRequired
                                                        options={(dataPersonal ?? []).map(el => ({
                                                            label: `${el.Item.Codigo} - ${el.Item.Nombre}${el.Lote ? ` - Lt: ${el.Lote}` : ''}`,
                                                            value: el.ID_StockPersonal,
                                                            dataComplete: el
                                                        }))}
                                                        loading={isFetchingTransit || isLoadingEquiposPersonal}
                                                        disabled={isFetchingTransit || isLoadingEquiposPersonal}
                                                        disabledVirtualized
                                                        errors={errors}
                                                        touched={touched}
                                                    />
                                                    : <InputSelect
                                                        label='Material instalado (a)'
                                                        name='material'
                                                        onChange={async (name, value: DtoValueOnSelect<StockAlmacenENTITY>) => {
                                                            try {
                                                                const { transito } = await getTransitSomacylOrdersQuery(value.dataComplete.ID_StockAlmacen)
                                                                const { Ingreso, Despacho, Devolucion, Liquidacion } = value.dataComplete
                                                                const disponible = Ingreso - Despacho + Devolucion - Liquidacion - transito
                                                                await setFieldValue('disponible', disponible)

                                                                handleChange({ target: { value, name } })
                                                                if (value.dataComplete.Item.Ind_SB === 'S') {
                                                                    await findOneStockAlmacenEquipos({ StockAlmacen: value.dataComplete })
                                                                    await setFieldValue('cantidad', 1)
                                                                } else {
                                                                    await setFieldValue('equipo', new DtoValueOnSelect<EquipoLogisticaDTO>())
                                                                    await setFieldValue('cantidad', 0)
                                                                }
                                                                handleChange({ target: { value, name } })
                                                            } catch (error) {
                                                                console.error(error)
                                                                AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                            }
                                                        }}
                                                        values={values}
                                                        isRequired
                                                        options={(dataAlmacen ?? []).map(el => ({
                                                            label: `${el.Item.Codigo} - ${el.Item.Nombre}${el.Lote ? ` - Lt: ${el.Lote}` : ''}`,
                                                            value: el.ID_StockAlmacen,
                                                            dataComplete: el
                                                        }))}
                                                        loading={isFetchingTransit || isLoadingEquiposAlmacen}
                                                        disabled={isFetchingTransit || isLoadingEquiposAlmacen}
                                                        disabledVirtualized
                                                        errors={errors}
                                                        touched={touched}
                                                    />
                                            }
                                        </Row>
                                        {
                                            values.material?.dataComplete?.Item?.Ind_SB === 'S'
                                                ? (
                                                    <Row className='align-items-top'>
                                                        <Col xs={10}>
                                                            <InputSelect
                                                                label='Equipo'
                                                                name='equipo'
                                                                onChange={(name, value: DtoValueOnSelect<EquipoLogisticaDTO>) => {
                                                                    try {
                                                                        handleChange({ target: { value, name } })
                                                                    } catch (error) {
                                                                        console.error(error)
                                                                        AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                                    }
                                                                }}
                                                                values={values}
                                                                isRequired
                                                                options={equipos}
                                                                loading={isLoadingEquiposPersonal || isLoadingEquiposAlmacen || isFetchingTransit}
                                                                disabled={isLoadingEquiposPersonal || isLoadingEquiposAlmacen || isFetchingTransit}
                                                                disabledVirtualized
                                                                errors={errors}
                                                                touched={touched}
                                                            />
                                                        </Col>
                                                        <Col xs={2}>
                                                            <Button
                                                                type='button'
                                                                variant='outline-primary'
                                                                onClick={async () => {
                                                                    try {
                                                                        if (!StrichSDK.isInitialized()) {
                                                                            await StrichSDK.initialize(sdkLicenseKey());
                                                                        }
                                                                        const detections = await PopupScanner.scan({
                                                                            symbologies: ['code128', 'qr', 'datamatrix']
                                                                        })

                                                                        if (!detections) {
                                                                            console.warn(`No se pudo detectar codigo`)
                                                                            return
                                                                        }

                                                                        const code = detections[0].data

                                                                        const equipoEncontrado = equipos.find(
                                                                            (e) => e.value === code
                                                                        )

                                                                        if (!equipoEncontrado) {
                                                                            AdapterGenerico.createMessage('Alerta', 'Equipo no encontrado', 'warning')
                                                                            return
                                                                        }

                                                                        handleChange({
                                                                            target: {
                                                                                name: 'equipo',
                                                                                value: equipoEncontrado
                                                                            }
                                                                        })
                                                                    } catch (error) {
                                                                        console.error(error)
                                                                        AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                                    }
                                                                }}
                                                                className='mt-4 w-100'
                                                                size='sm'
                                                            >
                                                                <MdQrCodeScanner size={16} />
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                )
                                                : null
                                        }
                                        <Row>
                                            <Col >
                                                <InputNumber
                                                    label='Disponible'
                                                    name='disponible'
                                                    errors={errors}
                                                    touched={touched}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    type='number'
                                                    readOnly
                                                />
                                            </Col>
                                            <Col>
                                                <InputNumber
                                                    label='Cantidad'
                                                    name='cantidad'
                                                    errors={errors}
                                                    touched={touched}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    required
                                                    type='number'
                                                    disabled={values.material?.dataComplete?.Item?.Ind_SB === 'S'}
                                                />
                                            </Col>
                                        </Row>
                                        {
                                            values.material?.dataComplete?.Item?.Nombre?.includes('CONTADOR') &&
                                            <>
                                                <Row>
                                                    <InputSelect
                                                        label='Material retirado'
                                                        name='item'
                                                        onChange={(name, value: DtoValueOnSelect<ItemEspañaENTITY>) => {
                                                            try {
                                                                handleChange({ target: { value, name } })
                                                            } catch (error) {
                                                                console.error(error)
                                                                AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                            }
                                                        }}
                                                        values={values}
                                                        options={dataItems.map(el => ({
                                                            label: `${el.Codigo} - ${el.Descripcion}`,
                                                            value: el.Codigo,
                                                            dataComplete: el
                                                        }))}
                                                        disabled
                                                        disabledVirtualized
                                                        errors={errors}
                                                        touched={touched}
                                                    />
                                                </Row>
                                                <Row>
                                                    <InputNumber
                                                        type='text'
                                                        label='Serie retirado'
                                                        name='serialDeinstall'
                                                        errors={errors}
                                                        touched={touched}
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </Row>
                                            </>
                                        }
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <InputNumber
                                            type='text'
                                            label='Lectura Contador Retirado'
                                            name='lecturaContadorRetirado'
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            handleChange={handleChange}
                                            required
                                            disabled={!!row.inventory.length}
                                        />
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <InputNumber
                                            type='text'
                                            label='Lectura Contador Instalado'
                                            name='lecturaContadorInstalado'
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            handleChange={handleChange}
                                            required
                                            disabled={!!row.inventory.length}
                                        />
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <InputNumber
                                            type='text'
                                            label='Observaciones'
                                            name='observaciones'
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            handleChange={handleChange}
                                            required
                                            disabled={!!row.inventory.length}
                                        />
                                    </ListGroup.Item>
                                    {/* Combo oculto: la clasificación se gestiona en FinalizeOrder (NO_FINALIZADA) */}
                                    {/* <ListGroup.Item>
                                        <InputSelect
                                            label='Clasificación Incidencia'
                                            name='clasificacion_incidencia'
                                            onChange={(name, value: DtoValueOnSelect<ClasificacionIncidencia>) => {
                                                try {
                                                    handleChange({ target: { value, name } })
                                                } catch (error) {
                                                    console.error(error)
                                                    AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                }
                                            }}
                                            values={values}
                                            options={dataClasificacion.map(el => ({
                                                label: el.id,
                                                value: el.id,
                                                dataComplete: el
                                            }))}
                                            disabled={!!row.inventory.length}
                                            disabledVirtualized
                                            errors={errors}
                                            touched={touched}
                                        />
                                    </ListGroup.Item> */}
                                </ListGroup>
                                <Row>
                                    <Col>
                                        <Button
                                            className='w-100'
                                            disabled={isFetchingTransit || loadingLocation}
                                            type='submit'
                                            variant='secondary'
                                        >
                                            {isFetchingTransit || loadingLocation ? 'Cargando…' : 'Guardar'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                            <Photos
                                row={row}
                                uploadPhotosSomacylOrders={uploadPhotosSomacylOrders}
                                isLoading={isFetchingTransit}
                            />
                        </>
                    )
                }
            }
        </Formik>
    )
}